import React, {useMemo, useState, useEffect} from 'react'
import {withRouter} from "react-router";
import {connect} from 'react-redux'
import Form from "components/Form";
import ValidationShema from "constants/ValidationShema";
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import Button from "components/Button";
import Tr from "translations/Translations";
import GridBlock from "components/GridBlock";
import RouterPath from "libs/RouterPath";
import NationalNoticeService from "services/NationalNoticeService";
import {DemandValidation, DemandValidationKeys} from "constants/DemandValidation";
import DemandValidationMessages from "components/DemandValidationMessages";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import {Typography} from "@material-ui/core";
import BzpNoticeDialog from "./BzpNoticeDialog";
import NationalNoticeStatus from "components/complex/nationalNotice/constants/NationalNoticeStatus";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    center: {
        textAlign: "center"
    }
}));

function NationalNoticeSection(
    {
        match,
        demandValidation,
        demandHeader,
        bzpContractNoticeStatus
    }) {

    const demandId = match.params.id;
    const [dialogOpen, setDialogOpen] = useState(false);
    const section = demandValidation.find(x => x.section === DemandValidation.NATIONAL_NOTICE);
    const editable = section ? section.editable : false;
    const handleSubmit = () => NationalNoticeService.saveContractNoticeSection(demandId)
    const bzpNoticeContentPresent = section?.bzpNoticeContentPresent;
    const hasBzpNotice = demandHeader?.noticeBzpType === true;
    const classes = useStyle();

    useEffect(() => {
            if (hasBzpNotice)
                NationalNoticeService.getContractNoticeStatus(demandId);
    }, [demandId, hasBzpNotice])

    const reqSectionsError = useMemo(() => {
        const sections = [];
        sections.push(demandValidation.find(x => x.section === DemandValidation.SCHEDULE));
        if (!demandHeader.passiveOfferForm) {
            sections.push(demandValidation.find(x => x.section === DemandValidation.DEALINGS));
        }
        const errorSections = sections.filter(s => s.status !== DemandValidationSectionStatus.OK).map(s => Tr(DemandValidationKeys[s.section]));

        if (errorSections.length > 0) {
            return `${Tr("national_notice_sections_missing")}: '${errorSections.join("', '")}'`
        }
        return undefined;
    }, [demandValidation, demandHeader]);

    const handleClick = () => {
        const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_NATIONAL_NOTICE_FORM_TYPE_ID, { formType: "contractNotice", id: demandId });
        RouterPath.redirect(href);
    }

    const handleOpenPreview = () => {
        setDialogOpen(true);
    }

    const handleClosePreview = () => {
        setDialogOpen(false);
    }

    return (<div style={{width: "100%"}}>
        {!!reqSectionsError && <Typography color="error">{reqSectionsError}</Typography>}
        <DemandValidationMessages section={section} editable={editable}/>
        <Form
            onSubmit={handleSubmit}
            id='mp_1_national_notice'
            validationSchema={ValidationShema.any()}
            afterSubmitFunc={() => {
                if (isDemandModification()) {
                    ModificationService.isDemandChanged(demandId);
                }
            }}
        >
            {(formikProps) => (<>
                <GridBlock justify="center" alignItems="center">
                    {(bzpContractNoticeStatus?.status !== NationalNoticeStatus.PUBLISHED || isDemandModification()) && <div className={classes.center}><Button disabled={!!reqSectionsError}
                        onClick={handleClick}>{Tr("bzp_notice_create")}</Button>
                    <Typography><br/>{Tr("bzp_notice_create_info")}<br/><br/></Typography></div>}
                    <br/><br/>
                    {!!bzpNoticeContentPresent && (
                        <Button
                            disabled={!!reqSectionsError}
                            onClick={handleOpenPreview}>
                            {Tr("preview_published_notice")}
                        </Button>
                    )}
                </GridBlock>
            </>
            )}
        </Form>
        {!!bzpNoticeContentPresent && (
            <BzpNoticeDialog
                id={demandId}
                open={dialogOpen}
                onClose={handleClosePreview}
            />
        )}
    </div>)
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
    demandHeader: state.resources.demandHeader,
    bzpContractNoticeStatus: state.resources[NationalNoticeService.BZP_CONTRACT_NOTICE_STATUS]
}), {})(withRouter(NationalNoticeSection));
